import React, { useEffect, useState } from 'react';
import { Autocomplete, Box, Checkbox, CircularProgress, Collapse, FormControlLabel, Grid, IconButton, ListItem, ListItemText, Stack, TextField, Tooltip, Typography } from '@mui/material';
import { MdiIcon, Table, useSnackbar } from '@components';
import { useFormik } from 'formik';
import * as yup from 'yup';
import { mdiChevronUp, mdiContentSave, mdiMagnify, mdiPencil, mdiPlus } from '@mdi/js';
import moment from 'moment';
import { InfoDialog } from './infoDialog';
import { useModal } from 'mui-modal-provider';
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
const EmpresasAssociadas = ({ $state, CrmService, user }) => {
    const [dataEmpresaAssociada, setDataEmpresaAssociada] = useState(); // dados dos clientes
    const [loadingEmpresaAssociada, setLoadingEmpresaAssociada] = useState(true);
    const [refetchingEmpresaAssociada, setRefetchingEmpresaAssociada] = useState(false);
    const [filterEmpresaAssociada, setFilterEmpresaAssociada] = useState([]); // filtros a aplicar na tabela
    const [sortEmpresaAssociada, setSortEmpresaAssociada] = useState([]); // ordenação da tabela
    const [optionsEmpresaAssociada, setOptionsEmpresaAssociada] = useState({
        filter: [], // exemplo -> [{name: 'nome', type: 'TEXT'}, {name: 'ultimoContacto', type: 'DATE', options: {format: 'YYYY-MM-DD'}}, ...]
        sort: [] // exemplo -> ['id', 'nome', 'ultimoContacto', 'contactoTelefonico', 'nif', 'email', 'morada', 'localidade']
    });
    const [paginationEmpresaAssociada, setPaginationEmpresaAssociada] = useState({
        pageIndex: 0,
        pageSize: 5
    });
    const [expand, setExpand] = useState(false);
    const [updateContacto, setUpdateContacto] = useState(false);
    const [isUpdate, setIsUpdate] = useState(false);
    const [value, setValue] = useState(null);
    const [options, setOptions] = useState([]);
    const [inputValue, setInputValue] = useState('');
    const [loading, setLoading] = useState(false);
    const { showSnackbar } = useSnackbar();
    const validationSchema = yup.object().shape({
        clienteId: yup
            .number()
            .required('Este campo é obrigatório')
            .test('exists', 'O contacto já se encontra associado à empresa', async (value) => {
            if (!value)
                return true;
            console.log(user);
            if (isUpdate && value === user.clienteId)
                return true;
            const d = await CrmService.existsContactoInCliente(user.id, value);
            return d.count === 0;
        })
    });
    const { showModal } = useModal();
    const formik = useFormik({
        initialValues: {
            ent: moment()
        },
        enableReinitialize: false,
        validateOnMount: false,
        validationSchema: validationSchema,
        validateOnChange: false,
        onSubmit: async (values) => {
            submit(values);
        }
    });
    const submit = async (val) => {
        val.contactoId = user.id;
        if (val.ent && moment(val.ent).isValid()) {
            val.dataEntrada = moment(val.ent).format();
        }
        else {
            val.dataEntrada = undefined;
        }
        if (val.sai && moment(val.sai).isValid()) {
            val.dataSaida = moment(val.sai).format();
        }
        else {
            val.dataSaida = undefined;
        }
        try {
            if (!isUpdate) {
                await CrmService.createContactoCliente(val);
                if (updateContacto) {
                    await CrmService.patchContacto(user.id, { clienteId: val.clienteId });
                }
            }
            else {
                await CrmService.patchContactoCliente(val.id, val);
            }
            showSnackbar(isUpdate ? 'Dados editados com sucesso' : 'Cliente associado registado com sucesso');
            formik.resetForm();
            setExpand(false);
        }
        catch (error) {
            showSnackbar(`Ocorreu um erro ao ${isUpdate ? 'editar' : 'inserir'} cliente associado`);
        }
        fetchData();
    };
    useEffect(() => {
        let active = true;
        const test = async () => {
            if (inputValue === '') {
                setOptions([]);
                return;
            }
            setLoading(true);
            try {
                let data = await CrmService.lookupCliente(inputValue);
                if (active) {
                    setOptions(data);
                }
            }
            catch (e) {
                console.error(e);
            }
            finally {
                if (active)
                    setLoading(false);
            }
        };
        test();
        return () => {
            active = false;
        };
    }, [inputValue]);
    // Filtragem dentro de cada coluna
    // Modo de filtro (igual a, contém, começa com... )
    const getType = (type) => {
        switch (type) {
            case 'contains':
                return '$ilike';
            case 'startsWith':
                return '$sw';
            case 'notEquals':
                return '$not';
            case 'empty':
                return '$null';
            case 'notEmpty':
                return '$notNull';
            case 'greaterThan':
                return '$gt';
            case 'greaterThanOrEqualTo':
                return '$gte';
            case 'lessThan':
                return '$lt';
            case 'lessThanOrEqualTo':
                return '$lte';
            default:
                return '$eq';
        }
    };
    // ir para detalhes da empresa (envia id da empresa)
    const onCellView = (cell) => {
        //$state.go('app.crm.empresas.details', { id: cell.id });
    };
    const initialFetch = async () => {
        if (loadingEmpresaAssociada) {
            // opt -> vai buscar os campos filtraveis
            const opt = await CrmService.optionsEmpresaAssociada();
            setOptionsEmpresaAssociada(opt);
            setLoadingEmpresaAssociada(false);
        }
    };
    const fetchData = async () => {
        try {
            let filters = {};
            filterEmpresaAssociada.forEach(r => {
                filters[r.id] = `${getType(r.type)}:${r.value}`;
            });
            let sorter = [];
            sortEmpresaAssociada.forEach(r => {
                sorter.push(`${r.id}:${r.desc ? 'DESC' : 'ASC'}`);
            });
            if (user !== undefined) {
                filters['contactoId'] = `$eq:${user.id}`;
            }
            // aux vai buscar os dados consoante os filtros
            const aux = await CrmService.findAllEmpresaAssociada({
                limit: paginationEmpresaAssociada.pageSize,
                page: paginationEmpresaAssociada.pageIndex + 1,
                filter: filters,
                sortBy: sorter
            });
            // Update URL
            $state.go($state.current.name, {
                limit: paginationEmpresaAssociada.pageSize,
                page: paginationEmpresaAssociada.pageIndex + 1,
                sortBy: sorter,
                filter: Object.keys(filterEmpresaAssociada).length > 0 ? JSON.stringify(filters) : undefined
            }, {
                notify: false,
                reload: false,
                location: 'replace',
                inherit: true
            });
            setDataEmpresaAssociada(aux);
        }
        catch (e) {
            console.log(e);
        }
        setRefetchingEmpresaAssociada(false);
    };
    useEffect(() => {
        initialFetch();
        if (!refetchingEmpresaAssociada) {
            setRefetchingEmpresaAssociada(true);
            fetchData();
        }
    }, [paginationEmpresaAssociada, filterEmpresaAssociada, sortEmpresaAssociada]);
    console.log(formik);
    return (<Box>
      <Stack direction='column'>
        <Stack direction='row' spacing={1} justifyContent='flex-start' alignItems='center'>
          <Typography variant='h6' sx={{ color: 'black' }}>
            Clientes associados
          </Typography>
          {expand ? (<Tooltip title={'Cancelar'}>
              <IconButton color='primary' onClick={() => {
                formik.resetForm();
                setExpand(!expand);
            }}>
                <MdiIcon path={mdiChevronUp} sx={{ color: '#1976D2' }}/>
              </IconButton>
            </Tooltip>) : (<Box></Box>)}

          <Tooltip title={'Guardar dados'}>
            <IconButton color='primary' onClick={() => {
            if (expand) {
                formik.handleSubmit();
            }
            else {
                formik.resetForm();
                setOptions([]);
                setUpdateContacto(false);
                setIsUpdate(false);
                setExpand(!expand);
            }
        }}>
              <MdiIcon path={!expand ? mdiPlus : mdiContentSave} sx={{ color: '#1976D2' }}></MdiIcon>
            </IconButton>
          </Tooltip>
        </Stack>
      </Stack>

      <Collapse in={expand}>
        <Grid container spacing={2}>
          <Grid item xs={12} md={8}>
            <Autocomplete disabled={isUpdate} value={value} // O valor completo da opção selecionada
     onChange={(event, newValue) => {
            setValue(newValue);
            formik.setFieldValue('clienteId', newValue.id, true);
            formik.setFieldTouched('clienteId', true);
        }} isOptionEqualToValue={(e, v) => {
            return e.id === v.id;
        }} inputValue={inputValue} onInputChange={(_, newInputValue) => setInputValue(newInputValue)} options={options} noOptionsText={inputValue === '' || inputValue.length < 2 ? 'Introduza um termo de pesquisa' : 'Nenhum cliente encontrado'} loadingText={'A carregar ...'} getOptionLabel={option => option.nome} loading={loading} renderOption={(props, option) => (<ListItem {...props} key={option.id} dense>
                  <ListItemText primary={option.nome}/>
                </ListItem>)} renderInput={params => (<TextField {...params} name='clienteId' label='Cliente' required={true} disabled={isUpdate} size='small' fullWidth onBlur={formik.handleBlur} error={formik.touched.clienteId && Boolean(formik.errors.clienteId)} helperText={formik.touched.clienteId && formik.errors.clienteId} InputProps={{
                ...params.InputProps,
                endAdornment: (<>
                        {loading ? <CircularProgress color='inherit' size={20}/> : null}
                        {params.InputProps.endAdornment}
                      </>)
            }}/>)}/>
            {!isUpdate && (<FormControlLabel control={<Checkbox value={updateContacto} onChange={e => {
                    setUpdateContacto(e.target.checked);
                }}/>} label='Marcar como atual'/>)}
          </Grid>

          <Grid item xs={12} md={4}>
            <TextField fullWidth name='cargo' label='Cargo' color='info' size='small' onBlur={formik.handleBlur} onChange={formik.handleChange} value={formik.values.cargo ?? ''} error={formik.touched.cargo && Boolean(formik.errors.cargo)} helperText={formik.touched.cargo && formik.errors.cargo}/>
          </Grid>

          <Grid item xs={6}>
            <LocalizationProvider dateAdapter={AdapterMoment}>
              <DatePicker value={formik.values.ent} onChange={value => {
            formik.setFieldValue('ent', moment(value));
        }} slotProps={{
            textField: {
                size: 'small',
                fullWidth: true,
                label: 'Data de entrada',
                helperText: formik.touched.ent && formik.errors.ent,
                error: Boolean(formik.touched.ent && formik.errors.ent)
            }
        }}/>
            </LocalizationProvider>
          </Grid>
          <Grid item xs={6}>
            <LocalizationProvider dateAdapter={AdapterMoment}>
              <DatePicker value={formik.values.sai} onChange={value => {
            formik.setFieldValue('sai', moment(value));
        }} slotProps={{
            textField: {
                size: 'small',
                fullWidth: true,
                label: 'Data de saída',
                helperText: formik.touched.sai && formik.errors.sai,
                error: Boolean(formik.touched.sai && formik.errors.sai)
            }
        }}/>
            </LocalizationProvider>
          </Grid>
        </Grid>
      </Collapse>

      <Box sx={{
            mt: 2,
            borderRadius: '15px',
            border: '1px solid #e0e0e0',
            overflow: 'hidden',
            boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)'
        }}>
        <Table onDoubleClick={row => {
            onCellView(row);
        }} storageKey={$state.current.name} data={dataEmpresaAssociada} columns={[
            {
                accessorKey: 'CoreCliente.nome',
                header: 'Cliente',
                size: 100
            },
            {
                accessorKey: 'dataEntrada',
                header: 'Data de entrada',
                size: 100,
                Cell: ({ renderedCellValue }) => (renderedCellValue ? moment(renderedCellValue).format('DD/MM/YYYY') : '-')
            },
            {
                accessorKey: 'dataSaida',
                header: 'Data de saída',
                size: 100,
                Cell: ({ renderedCellValue }) => (renderedCellValue ? moment(renderedCellValue).format('DD/MM/YYYY') : '-')
            },
            {
                accessorKey: 'cargo',
                header: 'Cargo',
                size: 100
            }
        ]} initial={{
            sort: sortEmpresaAssociada,
            filter: filterEmpresaAssociada
        }} isLoading={refetchingEmpresaAssociada} options={optionsEmpresaAssociada} onPaginate={setPaginationEmpresaAssociada} onFilter={setFilterEmpresaAssociada} onSort={setSortEmpresaAssociada} rowActionSize={100} actionItems={({ row }) => [
            <Box key={`action-items-${row.original.id}`} display='flex' gap={1}>
              {!expand && (<Tooltip key={`edit-tooltip-${row.original.id}`} title={'Editar dados'} placement='left'>
                  <IconButton color='primary' onClick={() => {
                        setValue(row.original.CoreCliente);
                        setOptions([row.original.CoreCliente]);
                        setIsUpdate(true);
                        formik.resetForm();
                        formik.setValues({
                            id: row.original.id,
                            clienteId: row.original.clienteId,
                            cargo: row.original.cargo,
                            ent: row.original.dataEntrada ? moment(row.original.dataEntrada) : null,
                            sai: row.original.dataSaida ? moment(row.original.dataSaida) : null
                        });
                        if (!expand)
                            setExpand(true);
                    }}>
                    <MdiIcon path={mdiPencil} sx={{ color: '#1976D2' }}/>
                  </IconButton>
                </Tooltip>)}
              <Tooltip key={`view-tooltip-${row.original.id}`} title={'Ver detalhes'} placement='top'>
                <IconButton color='secondary' onClick={() => {
                    const showData = [
                        { key: 'Cliente', value: row.original.nomeCoreCliente },
                        { key: 'Data de entrada', value: row.original.dataEntrada ? moment(row.original.dataEntrada).format('DD/MM/YYYY') : 'N/D' },
                        { key: 'Data de saída', value: row.original.dataSaida ? moment(row.original.dataSaida).format('DD/MM/YYYY') : 'N/D' }
                    ];
                    showModal(InfoDialog, {
                        title: 'Detalhes do Cliente',
                        data: showData
                    });
                }}>
                  <MdiIcon path={mdiMagnify} sx={{ color: '#1976D2' }}/>
                </IconButton>
              </Tooltip>
            </Box>
        ]}></Table>
      </Box>
    </Box>);
};
export default EmpresasAssociadas;
